export function sanitalize(valor) {
  if (!valor) return;
  return parseFloat(String(valor).replace(",", "."));
}
